import { ORDER_META_KEY } from "../constants.js";
import { metaContainsKey } from "@cappelendamm/crystallize-utils";
export const isOrderCredited = (order) => {
    return metaContainsKey(order.meta, ORDER_META_KEY.ORDER.CREDIT_ORDER_IDS);
};
